import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import globalNav from "./components/Nav.vue";//全局的顶部
import VueCookies from "vue-cookies";
import userCode from "@/util/allCode.js";
import '@/assets/iconfont/font/iconfont.css'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
import VueClipboard from 'vue-clipboard2'


import { navList } from "@/util/api.js";
import "reset-css";

Vue.use(ElementUI);
Vue.use(VueCookies);
Vue.use(VueClipboard);
Vue.component("globalNav", globalNav);
import axios from "axios";
Vue.prototype.$axios = axios;
import $ from "jquery";
Vue.prototype.$ = $;
Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  checkLogin(to, next);
});
function pcUrl() {
  let geturl = window.location.href;
  let getqyinfo = geturl.split("?")[1];
  let getqys = new URLSearchParams("?" + getqyinfo);
  let getqycode = getqys.get("SSOID");
  return getqycode;
}
// app使用h5页面
function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return r[2];
  return null;
}
function checkLogin(to, next) {
  let SSOID = GetQueryString("SSOID") || pcUrl() || $cookies.get("SSOID");
  var url = "https://sso.chci.cn/ssoJsonLogin.do";
  if (SSOID) {
    console.log("有SSOID", SSOID);
    url = "https://sso.chci.cn/ssoJsonLogin.do?ticket=" + SSOID;
  }
  console.log(url);
  $.ajax({
    //备用请求 和下面的vue-jsop实际效果是一样的  只不过这个是jq
    url: url,
    type: "GET",
    async: false,
    dataType: "jsonp",
    jsonp: "mycallback",
    xhrFields: {
      withCredentials: true, //解决跨服务传递时不传递cookie的问题，允许携带证书
    },
    crossDomain: true, //允许跨域
    timeout: 5000,
    success: async function (data) {
      console.log("[ data ] >", data);
      // 不需要登录的界面
      // 没有登录
      if (data.error) {
        store.state.onceRequest=false//让登录接口掉用一次只
        store.commit("closeAllTab")//账号失效清空上面的tab
        // 去登录界面
        let returnUrl = encodeURIComponent(window.location.href);
        window.location.href =
          "https://sso.chci.cn/login.do?method=get&returnURL=" + returnUrl;
        return;
      }
      await  setDomainCookie(data);
      await saveNavCode(next, to);
      // ----- 调取接口  存store侧边栏  处理 地址路由
    },
  });
}
async function saveNavCode(next, to) {
  let data = await navList(
    { userName: $cookies.get("username") },
    $cookies.get("SSOID")
  );
  if (data.success) {
    // 当前登录人的身份
    $cookies.set("roleType", data.result.roleType, "0");
    if(data.result.roleCode=="all"){
       $cookies.set("roleCode", "home,qyk,qysh,hygl,smxx,jsgl,czrz", "0");
       if(to.path=="/"){
         next("/home")
       }
       next()
    }else{
      let routerCode = data.result.roleCode.split(",");
      $cookies.set("roleCode", data.result.roleCode, "0");
      let rolePath=[]
      userCode.map((item)=>{
        if(routerCode.indexOf(item.code)!=-1){
          rolePath.push(item.path)
        }
      })
      if(to.path=="/noper"){
        next("/home")
      }
      if(to.path == "/home"){
        next()
      } else if (to.path == "/") {
        next("/home");
      } else if (rolePath.indexOf(to.path) != -1)  {
          next();
      }else {
        next("/home");
      }
    }
    
  } else {
    $cookies.set("roleCode", "", "0");
    $cookies.set("roleType", "", "0");
    if(to.path == "/noper"){
      next()
    }else{
      next("/noper");
    }
  }
}
function setDomainCookie(data) {
  store.state.userinfo = data;
  $cookies.set("SSOID", data.ticketVo.ticketEncryptKey, "0"); ///保存请求返回所有信息
  $cookies.set("username", data.ticketVo.username, "0"); ///保存请求返回所有信息
  $cookies.set("isLogin", true, "0"); ///保存请求返回所有信息
  $cookies.set("areaLayer", data.user.kqlayer, "0"); ///保存请求返回所有信息
  setDomainStoreState();
}

function setDomainStoreState() {
  store.state.isLogin = $cookies.get("isLogin");
  store.state.SSOID = $cookies.get("SSOID"); //所属管理地区
  store.state.userName = $cookies.get("username"); //保存请求返回所有信息
  store.state.areaLayer = $cookies.get("areaLayer"); //保存请求返回所有信息
}
function clearDomain() {
  $cookies.remove("isLogin");
  $cookies.remove("SSOID");
  $cookies.remove("username");
  $cookies.remove("areaLayer");
  store.state.isLogin = $cookies.get("isLogin"); //所属管理地区
  store.state.SSOID = $cookies.get("SSOID"); //保存请求返回所有信息
  store.state.userName = $cookies.get("username"); //保存地区编码
  store.state.areaLayer = $cookies.get("areaLayer"); //保存地区编码
}
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
